document.querySelectorAll('.mc-services-menu').forEach(menu=>{
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary')?.focus();}});
  document.addEventListener('click',event=>{if(!menu.contains(event.target))menu.open=false;});
});
// Shopify's native consent banner is injected after the theme loads. Keep its
// controls French without changing consent state or the underlying privacy URL.
const localizeConsentBanner=()=>{
  const banner=document.querySelector('#shopify-pc__banner');
  if(!banner)return;
  const replacements=[
    ['Cookie consent','Consentement aux cookies'],
    ['We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our Privacy Policy','Nous et nos partenaires, dont Shopify, utilisons des cookies et technologies similaires pour personnaliser votre expérience, afficher des publicités et analyser la fréquentation. Ces technologies ne sont utilisées à ces fins qu’avec votre accord. Consultez notre politique de confidentialité.'],
    ['Manage preferences','Gérer mes préférences'],['Accept','Accepter'],['Decline','Refuser']
  ];
  const walker=document.createTreeWalker(banner,NodeFilter.SHOW_TEXT);
  const nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);
  nodes.forEach(node=>{let value=node.nodeValue;replacements.forEach(([from,to])=>{if(value.trim()===from)value=value.replace(from,to)});node.nodeValue=value});
};
localizeConsentBanner();
new MutationObserver(localizeConsentBanner).observe(document.documentElement,{subtree:true,childList:true});
// Keep captured editorial slideshow controls native and functional.
document.querySelectorAll('.mc-editorial-source .slideshow').forEach(slideshow=>{
  const tracks=[...slideshow.querySelectorAll('.slideshow__left,.slideshow__right,.slideshow__content')];
  if(!tracks.length)return;
  const count=Math.max(...tracks.map(track=>track.querySelectorAll('.slideshow__slide,.slideshow__box').length));
  if(count<2)return;
  let selected=0;
  const update=index=>{
    selected=(index+count)%count;
    tracks.forEach(track=>{
      const cells=[...track.querySelectorAll('.slideshow__slide,.slideshow__box')];
      cells.forEach((cell,i)=>{
        const active=i===selected%cells.length;
        cell.hidden=!active;
        cell.classList.toggle('is-selected',active);
        cell.classList.toggle('is-nav-selected',active);
        cell.style.transform='none';
        cell.setAttribute('aria-hidden',String(!active));
      });
      const slider=track.querySelector('.flickity-slider');
      if(slider)slider.style.transform='none';
    });
    slideshow.querySelectorAll('.flickity-page-dots .dot,.flickity-page-dot').forEach((dot,i)=>dot.classList.toggle('is-selected',i===selected));
  };
  slideshow.querySelectorAll('.flickity-prev-next-button').forEach(button=>{
    button.tabIndex=0;
    button.addEventListener('click',()=>update(selected+(button.classList.contains('previous')?-1:1)));
  });
  slideshow.querySelectorAll('.flickity-page-dots .dot,.flickity-page-dot').forEach((dot,i)=>{
    dot.tabIndex=0;
    dot.addEventListener('click',()=>update(i));
    dot.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();update(i);}});
  });
  update(0);
});
